import Hero from "../components/Hero";
import Stats from "../components/Stats";
import CoreValues from "../components/CoreValues";
import DataSecurity from "../components/DataSecurity";
import Workflow from "../components/Workflow";
import Footer from "../components/Footer";
import SEO from "../components/SEO";

function Home() {
  return (
    <>
      <SEO
        title="KMC Health (Kitmeechai Health) | Healthcare Solution"
        description="KMC Health (Kitmeechai Health) is an integrated health system enabler, redefining a future-forward healthcare via integrating health promotion and specific disease management that proactively shape better health and wellbeing for everyone, everywhere."
        path="/"
      />
      <div id="hero">
        <Hero />
      </div>
      <div id="stats">
        <Stats />
      </div>
      <div id="core-values">
        <CoreValues />
      </div>
      <div id="security">
        <DataSecurity />
      </div>
      <div id="workflow">
        <Workflow />
      </div>
      <Footer />
    </>
  );
}

export default Home;